import {Dialog} from "@material-ui/core";
import React, {useState} from "react";
import styled from "styled-components";
import {Colors} from "../constants/colors";
import {deleteUserUsingDELETE} from "../swagger/vue-api-client"
import ButtonWithoutIcon from "./buttons/ButtonWithoutIcon";
import ErrorAndLoadingMessage from "./ErrorAndLoadingMessage";
import DialogTitle from "./DialogTitle";
import DialogButtonsContainer from "./DialogButtonsContainer";
import {handleSignOut} from "../services/LinksService";

const DeleteAccountDialog = ({open, setOpen, history}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onDeleteAccount = () => {

        setIsLoading(true);

        deleteUserUsingDELETE({}).then(() => {
            setErrorMessage('')
            setIsLoading(false)
            setOpen(false)
            handleSignOut(history, "/konto-usuniete")
        }).catch(() => {
            setErrorMessage("Nie udało się usunąć konta")
            setIsLoading(false)
        })
    };

    return (
        <Dialog onClose={() => setOpen(false)} open={open} maxWidth={'sm'} fullWidth={true}>
            <DialogTitle title={"Czy na pewno chcesz usunąć swoje konto?"}/>
            <Container>
                <ErrorAndLoadingMessage errorMessage={errorMessage} isLoading={isLoading}/>
                <DialogButtonsContainer>
                    <ButtonWithoutIcon
                        label={"anuluj"}
                        onClick={() => setOpen(false)}
                    />
                    <ButtonWithoutIcon
                        label={"usuń"}
                        onClick={() => onDeleteAccount()}
                        backgroundColor={Colors.RED}
                    />
                </DialogButtonsContainer>
            </Container>
        </Dialog>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 40px 20px;
  text-align: center;
`;

export default DeleteAccountDialog;